import * as THREE from 'three'
import { Canvas } from '@react-three/fiber'
import { CameraControls, BakeShadows } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import { Instances, Model } from './Zdpzc'

// Switch off matrix updates, not needed for a static scene
THREE.Object3D.prototype.onUpdate = (self) => {
  self.matrixAutoUpdate = false
  self.matrixWorldAutoUpdate = false
  self.updateMatrix()
  self.updateMatrixWorld()
}

export default function App() {
  return (
    <Canvas dpr={[1, 1.5]} shadows camera={{ position: [-30, 30, 30], fov: 45 }}>
      <fog attach="fog" args={['#101015', -20, 100]} />
      <ambientLight intensity={0.25} />
      <spotLight intensity={4} position={[50, 50, 100]} angle={0.3} penumbra={1} castShadow shadow-mapSize={512} shadow-bias={-0.000001} />

      {/** The scene is static, frames=1 only calculates instance-matrices once */}
      <Instances frames={1} position={[0.6, 0, 2]} castShadow receiveShadow>
        <Model />
        {/** No matter how many instances you mount, draw calls will remain the same */}
        <Model position={[-25, 0, 0]} />
        {/** Unlike with imperative instances you can freely nest and group, instances behave like any other scene object */}
        <group position={[25, 0, 0]}>
          <Model />
        </group>

        {/** The <Instances> wrapper just tracks instances, you can have anything else in here, too */}
        <mesh receiveShadow scale={1000} rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry />
          <meshStandardMaterial color="black" />
        </mesh>
      </Instances>

      <CameraControls minPolarAngle={0} maxPolarAngle={Math.PI / 2.15} minDistance={5} maxDistance={60} />
      <BakeShadows />
      <Perf matrixUpdate />
    </Canvas>
  )
}
